import {DICTIONARY} from "../../dictionary";
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {GeneralService} from "../../services/generalService";
import {Router} from "@angular/router";

@Component({
	selector: 'support-menu-component',
	templateUrl: './support-menu.component.html',
})
export class SupportMenuComponent implements OnInit, OnDestroy{

	@Input() showOnboardingButton: boolean;
	@Output() onOnboardingBtnClick = new EventEmitter<boolean>();

	constructor(public gs:GeneralService,
				private router:Router) {
	}

	pageStyle = 0;
	dic = DICTIONARY;
	isPro;
	isEmdrSla;
	triggerContactUsFormSubscription; // TODO: remove

	ngOnInit() {
		if (location.hash.indexOf('plansignup') >= 0 || location.hash.indexOf('signup') >= 0 || location.hash.indexOf('trialsignup') >= 0) {
			this.pageStyle = 1;
		}
		else if (this.router.url.substring(1) !== this.dic.CONSTANTS.appStates.login) {
			this.pageStyle = 2;

			this.triggerContactUsFormSubscription = this.gs.triggerContactUsFormSubj.subscribe((data) => {
				if (!data) {return;}
			});

			this.gs.getUserInfo(false, userInfo => {
				this.isPro = userInfo?.plan?.plan === this.dic.CONSTANTS.planTypePro;
				if (userInfo.plan.emdr?.enabled) {
					this.isEmdrSla = true;
				}
			});
		}
	};

	ngOnDestroy() {
		this.triggerContactUsFormSubscription.unsubscribe();
	}

	goToTicketsPage = () => {
		this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
			this.router.navigate([this.dic.CONSTANTS.appStates.accountDetails, this.dic.CONSTANTS.supportPages.tickets], {state: {data: 'open'}});
		});
	}

	goToKnowledgeBase = (pageModel, anchorId=null) => {
		switch (pageModel) {
			case this.dic.CONSTANTS.supportPages.faq:
				if (this.gs.faq === this.dic.CONSTANTS.trustifiDefault.resources.faq) {
					this.router.navigate([this.dic.CONSTANTS.appStates.knowledge, this.dic.CONSTANTS.supportPages.faq]);
				}
				else {
					window.open(this.gs.faq,'_blank');
				}
				break;

			case this.dic.CONSTANTS.supportPages.knowledgeBase:
				if (anchorId === 'Sensitivity_Engine' && this.gs.sensitivityEngine !== this.dic.CONSTANTS.trustifiDefault.resources.sensitivityEngine) {
					window.open(this.gs.sensitivityEngine,'_blank');
				}
				else {
					this.router.navigateByUrl('/dummy', { skipLocationChange: true }).then(() => {
						this.router.navigate([this.dic.CONSTANTS.appStates.knowledge, this.dic.CONSTANTS.supportPages.knowledgeBase], {state: {anchorId}});
					});
				}
				break;

			default:
				this.router.navigate([this.dic.CONSTANTS.appStates.knowledge, pageModel]);
		}
	};
}



